module.exports = __webpack_public_path__ + "img/vpn-1.6207d136.jpg";